// TipLock Portal Route Configuration
import { lazy } from 'react';

// Lazy load TipLock Portal components
const TiplockDashboard = lazy(
  () => import('../../portals/tiplock/pages/dashboard/TiplockDashboard')
);
const TiplockAlertsManagement = lazy(
  () => import('../../portals/tiplock/pages/alerts/TiplockAlertsManagement')
);
const TiplockEventsManagement = lazy(
  () => import('../../portals/tiplock/pages/events/TiplockEventsManagement')
);
const TiplockSuppressionManagement = lazy(
  () => import('../../portals/tiplock/pages/suppression/TiplockSuppressionManagement')
);
const TiplockSettings = lazy(() => import('../../portals/tiplock/pages/settings/TiplockSettings'));
const MySupportPage = lazy(() => import('../../shared/support/pages/MySupportPage'));

/**
 * TipLock Portal Routes Configuration
 * For TipLock staff monitoring Universal API account data
 */
export const tiplockRoutes = {
  path: '/tiplock',
  name: 'TipLock Portal',
  description: 'Portal for TipLock staff monitoring Universal API account data',
  requiredRoles: [], // Portal access determined by assigned_portal field
  requiredPermissions: [],
  children: [
    {
      index: true,
      component: TiplockDashboard,
      name: 'Dashboard',
      description: 'TipLock operations dashboard',
      requiredPermissions: [],
      meta: {
        title: 'TipLock Dashboard',
        breadcrumb: 'Dashboard',
        icon: 'dashboard',
      },
    },
    {
      path: 'alerts',
      component: TiplockAlertsManagement,
      name: 'Alerts Management',
      description: 'Manage and monitor TipLock alerts',
      requiredPermissions: [],
      meta: {
        title: 'Alerts Management',
        breadcrumb: 'Alerts',
        icon: 'warning',
      },
    },
    {
      path: 'events',
      component: TiplockEventsManagement,
      name: 'Events Management',
      description: 'Manage TipLock events',
      requiredPermissions: [],
      meta: {
        title: 'Events Management',
        breadcrumb: 'Events',
        icon: 'event',
      },
    },
    {
      path: 'suppression',
      component: TiplockSuppressionManagement,
      name: 'Suppression Management',
      description: 'Manage alert suppression',
      requiredPermissions: [],
      meta: {
        title: 'Suppression Management',
        breadcrumb: 'Suppression',
        icon: 'block',
      },
    },
    {
      path: 'settings',
      component: TiplockSettings,
      name: 'Settings',
      description: 'TipLock portal settings',
      requiredPermissions: [],
      meta: {
        title: 'TipLock Settings',
        breadcrumb: 'Settings',
        icon: 'settings',
      },
    },
    {
      path: 'my-support',
      component: MySupportPage,
      name: 'My Support',
      description: 'My tickets and notifications',
      requiredPermissions: [],
      meta: {
        title: 'My Support',
        breadcrumb: 'Support',
        icon: 'support_agent',
      },
    },
  ],
};

export default tiplockRoutes;
